/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
type BellIconProps = {
  className?: string;
  fill?: string;
};
const BellIcon = ({ className, fill = "white" }: BellIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg" test-id="CS_g9NkV">

      <path
        d="M64 156C72.8 156 80 148.8 80 140H48C48 148.8 55.2 156 64 156ZM112 108V68C112 43.44 98.96 22.88 76 17.44V12C76 5.36 70.64 0 64 0C57.36 0 52 5.36 52 12V17.44C29.12 22.88 16 43.36 16 68V108L0 124V132H128V124L112 108ZM96 116H32V68C32 48.16 44.08 32 64 32C83.92 32 96 48.16 96 68V116Z"
        fill="white" test-id="WdFLeY69" />

    </svg>);

};

export default BellIcon;